<template>
  <div id="state">
    <div v-if="isRegisted==1">
      <el-tabs style="min-height:800px" type="border-card" v-model="tab" @tab-click="handleClick">
        <el-tab-pane label="试剂" name="1">
          <div>
            <div style="margin-bottom:20px;">
              <el-row :gutter="10">
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">分类搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-select v-model="sClass" placeholder="请选择" size="mini">
                      <el-option v-for="item in classArr" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">项目搜索</span>
                </el-col>
                <el-col :span="3">
                  <div>
                    <el-select v-model="sProject" placeholder="请选择" size="mini">
                      <el-option v-for="item in nameList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">名称搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-input v-model="key_word" size="mini" placeholder="请输入库存名称"></el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <el-button size="mini" style="margin-left:10px;" @click="search">搜索</el-button>
                </el-col>
                <el-col :span="2" :push="3">
                  <div style="height:100%;line-height:25px;">
                    <el-link :underline="false" @click="tab = '6'">批量上传</el-link>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="data">
              <el-table :data="data" style="width: 100%;" border header-row-class-name="header">
                <el-table-column
                  type="index"
                  :index="indexMethod"
                  align="center"
                  prop="id"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column align="center" prop="buy_date" label="时间" width="100"></el-table-column>
                <el-table-column align="center" prop="name" label="名称描述" width="200"></el-table-column>
                <el-table-column align="center" prop="brand" label="品牌" width="100"></el-table-column>
                <el-table-column align="center" prop="item_no" label="货号" width="100"></el-table-column>
                <el-table-column align="center" prop="price" label="单价(元)" width="80"></el-table-column>
                <el-table-column align="center" prop="address" label="存放" width="100"></el-table-column>
                <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div align="center">
                      <div>
                        <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="detail(scope.row.id)">详情</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="buy_search(scope.row.name)">购买</el-link>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lv3Text" style="padding-top:20px;">
              <span style="cursor: pointer;" @click="detail(0)">
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                添加更多
              </span>
              <span style="float:right;cursor: pointer;margin-left:50px">
                <a
                  class="lv3Text"
                  target="_blank"
                  @click="setClass"
                  :href="serve + '/personal/export_inventory?mobile='+mobile+'&token='+token+'&money_class='+sClass+'&project='+sProject+'&class='+product_class"
                >导出列表</a>
              </span>
            </div>
            <div v-if="total>0" style="padding: 20px;" align="center">
              <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="page"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="抗体" name="7">
          <div>
            <div style="margin-bottom:20px;">
              <el-row :gutter="10">
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">分类搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-select v-model="sClass" placeholder="请选择" size="mini">
                      <el-option v-for="item in classArr" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">项目搜索</span>
                </el-col>
                <el-col :span="3">
                  <div>
                    <el-select v-model="sProject" placeholder="请选择" size="mini">
                      <el-option v-for="item in nameList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">名称搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-input size="mini" placeholder="请输入库存名称"></el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <el-button size="mini" style="margin-left:10px;" @click="search">搜索</el-button>
                </el-col>
                <el-col :span="2" :push="3">
                  <div style="height:100%;line-height:25px;">
                    <el-link :underline="false" @click="tab = '6'">批量上传</el-link>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="data">
              <el-table :data="data" style="width: 100%;" border header-row-class-name="header">
                <el-table-column
                  type="index"
                  :index="indexMethod"
                  align="center"
                  prop="id"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column align="center" prop="buy_date" label="时间" width="100"></el-table-column>
                <el-table-column align="center" prop="name" label="名称描述" width="200"></el-table-column>
                <el-table-column align="center" prop="brand" label="品牌" width="100"></el-table-column>
                <el-table-column align="center" prop="item_no" label="货号" width="100"></el-table-column>
                <el-table-column align="center" prop="price" label="单价(元)" width="80"></el-table-column>
                <el-table-column align="center" prop="address" label="存放" width="100"></el-table-column>
                <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div align="center">
                      <div>
                        <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="detail(scope.row.id)">详情</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="buy_search(scope.row.name)">购买</el-link>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lv3Text" style="padding-top:20px;">
              <span style="cursor: pointer;" @click="detail(0)">
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                添加更多
              </span>
              <span style="float:right;cursor: pointer;margin-left:50px">
                <a
                  class="lv3Text"
                  target="_blank"
                  @click="setClass"
                  :href="serve + '/personal/export_inventory?mobile='+mobile+'&token='+token+'&money_class='+sClass+'&project='+sProject+'&class='+product_class"
                >导出列表</a>
              </span>
            </div>
            <div v-if="total>0" style="padding: 20px;" align="center">
              <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="page"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="耗材" name="2">
          <div>
            <div style="margin-bottom:20px;">
              <el-row :gutter="10">
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">分类搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-select v-model="sClass" placeholder="请选择" size="mini">
                      <el-option v-for="item in classArr" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">项目搜索</span>
                </el-col>
                <el-col :span="3">
                  <div>
                    <el-select v-model="sProject" placeholder="请选择" size="mini">
                      <el-option v-for="item in nameList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">名称搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-input size="mini" placeholder="请输入库存名称"></el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <el-button size="mini" style="margin-left:10px;" @click="search">搜索</el-button>
                </el-col>
                <el-col :span="2" :push="3">
                  <div style="height:100%;line-height:25px;">
                    <el-link :underline="false" @click="tab = '6'">批量上传</el-link>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="data">
              <el-table :data="data" style="width: 100%;" border header-row-class-name="header">
                <el-table-column
                  type="index"
                  :index="indexMethod"
                  align="center"
                  prop="id"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column align="center" prop="buy_date" label="时间" width="100"></el-table-column>
                <el-table-column align="center" prop="name" label="名称描述" width="200"></el-table-column>
                <el-table-column align="center" prop="brand" label="品牌" width="100"></el-table-column>
                <el-table-column align="center" prop="item_no" label="货号" width="100"></el-table-column>
                <el-table-column align="center" prop="price" label="单价(元)" width="80"></el-table-column>
                <el-table-column align="center" prop="address" label="存放" width="100"></el-table-column>
                <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div align="center">
                      <div>
                        <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="detail(scope.row.id)">详情</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="buy_search(scope.row.name)">购买</el-link>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lv3Text" style="padding-top:20px;">
              <span style="cursor: pointer;" @click="detail(0)">
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                添加更多
              </span>
              <span style="float:right;cursor: pointer;margin-left:50px">
                <a
                  class="lv3Text"
                  target="_blank"
                  @click="setClass"
                  :href=" serve + '/personal/export_inventory?mobile='+mobile+'&token='+token+'&money_class='+sClass+'&project='+sProject+'&class='+product_class"
                >导出列表</a>
              </span>
            </div>
            <div v-if="total>0" style="padding: 20px;" align="center">
              <el-pagination
                background
                hide-on-single-page
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="page"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="仪器" name="3">
          <div>
            <div style="margin-bottom:20px;">
              <el-row :gutter="10">
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">分类搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-select v-model="sClass" placeholder="请选择" size="mini">
                      <el-option v-for="item in classArr" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">项目搜索</span>
                </el-col>
                <el-col :span="3">
                  <div>
                    <el-select v-model="sProject" placeholder="请选择" size="mini">
                      <el-option v-for="item in nameList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">名称搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-input size="mini" placeholder="请输入库存名称"></el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <el-button size="mini" style="margin-left:10px;" @click="search">搜索</el-button>
                </el-col>
                <el-col :span="2" :push="3">
                  <div style="height:100%;line-height:25px;">
                    <el-link :underline="false" @click="tab = '6'">批量上传</el-link>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="data">
              <el-table :data="data" style="width: 100%;" border header-row-class-name="header">
                <el-table-column
                  type="index"
                  :index="indexMethod"
                  align="center"
                  prop="id"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column align="center" prop="buy_date" label="时间" width="100"></el-table-column>
                <el-table-column align="center" prop="name" label="名称描述" width="200"></el-table-column>
                <el-table-column align="center" prop="brand" label="品牌" width="100"></el-table-column>
                <el-table-column align="center" prop="item_no" label="货号" width="100"></el-table-column>
                <el-table-column align="center" prop="price" label="单价(元)" width="80"></el-table-column>
                <el-table-column align="center" prop="address" label="存放" width="100"></el-table-column>
                <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div align="center">
                      <div>
                        <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="detail(scope.row.id)">详情</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="buy_search(scope.row.name)">购买</el-link>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lv3Text" style="padding-top:20px;">
              <span style="cursor: pointer;" @click="detail(0)">
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                添加更多
              </span>
              <span style="float:right;cursor: pointer;margin-left:50px">
                <a
                  class="lv3Text"
                  target="_blank"
                  @click="setClass"
                  :href="serve + '/personal/export_inventory?mobile='+mobile+'&token='+token+'&money_class='+sClass+'&project='+sProject+'&class='+product_class"
                >导出列表</a>
              </span>
            </div>
            <div v-if="total>0" style="padding: 20px;" align="center">
              <el-pagination
              hide-on-single-page
                background
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="page"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="技术服务" name="4">
          <div>
            <div style="margin-bottom:20px;">
              <el-row :gutter="10">
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">分类搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-select v-model="sClass" placeholder="请选择" size="mini">
                      <el-option v-for="item in classArr" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">项目搜索</span>
                </el-col>
                <el-col :span="3">
                  <div>
                    <el-select v-model="sProject" placeholder="请选择" size="mini">
                      <el-option v-for="item in nameList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="2" align="right">
                  <span style="display:inline-block;line-height:28px">名称搜索</span>
                </el-col>
                <el-col :span="4">
                  <div>
                    <el-input size="mini" placeholder="请输入库存名称"></el-input>
                  </div>
                </el-col>
                <el-col :span="2">
                  <el-button size="mini" style="margin-left:10px;" @click="search">搜索</el-button>
                </el-col>
                <el-col :span="2" :push="3">
                  <div style="height:100%;line-height:25px;">
                    <el-link :underline="false" @click="tab = '6'">批量上传</el-link>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="data">
              <el-table :data="data" style="width: 100%;" border header-row-class-name="header">
                <el-table-column
                  type="index"
                  :index="indexMethod"
                  align="center"
                  prop="id"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column align="center" prop="buy_date" label="时间" width="100"></el-table-column>
                <el-table-column align="center" prop="name" label="名称描述" width="200"></el-table-column>
                <el-table-column align="center" prop="brand" label="品牌" width="100"></el-table-column>
                <el-table-column align="center" prop="item_no" label="货号" width="100"></el-table-column>
                <el-table-column align="center" prop="price" label="单价(元)" width="80"></el-table-column>
                <el-table-column align="center" prop="address" label="存放" width="100"></el-table-column>
                <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <div align="center">
                      <div>
                        <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="detail(scope.row.id)">详情</el-link>
                      </div>
                      <div>
                        <el-link :underline="false" @click="buy_search(scope.row.name)">购买</el-link>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lv3Text" style="padding-top:20px;">
              <span style="cursor: pointer;" @click="detail(0)">
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                添加更多
              </span>
              <span style="float:right;cursor: pointer;margin-left:50px">
                <a
                  class="lv3Text"
                  target="_blank"
                  @click="setClass"
                  :href="serve + '/personal/export_inventory?mobile='+mobile+'&token='+token+'&money_class='+sClass+'&project='+sProject+'&class='+product_class"
                >导出列表</a>
              </span>
            </div>
            <div v-if="total>0" style="padding: 20px;" align="center">
              <el-pagination
              hide-on-single-page
                background
                layout="prev, pager, next"
                :total="total"
                :current-page.sync="page"
                @current-change="changePage"
              ></el-pagination>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="存放位置" name="5">
          <div v-if="show_this_address == 0">
            <div>
              <el-table
                :data="address_list"
                border
                style="width: 90%;margin:0 auto;"
                header-row-class-name="header"
                @cell-click="this_address"
              >
                <el-table-column align="center" label="选择" width="50">
                  <el-checkbox></el-checkbox>
                </el-table-column>
                <el-table-column align="center" prop="order_by" label="序号" width="100"></el-table-column>
                <el-table-column align="center" prop="address" label="存放位置" width="150"></el-table-column>
                <el-table-column align="center" prop="remark" label="备注"></el-table-column>
                <el-table-column align="center" label="操作" width="150">
                  <template slot-scope="scope">
                    <div align="center">
                      <el-link :underline="false" @click="chaneg_order_by(1,scope.row.id)">上移</el-link>
                      <el-link
                        :underline="false"
                        style="margin:0 10px 0 10px"
                        @click="chaneg_order_by(0,scope.row.id)"
                      >下移</el-link>
                      <el-link :underline="false" @click="delete_address(scope.row.id)">删除</el-link>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="lv3Text" style="padding-top:20px;margin-left:5%;margin-right:5%;">
              <span style="cursor: pointer;" @click="dialogFormVisible = true">
                <span style="margin-right:5px">
                  <i class="fas fa-plus-square fa-lg"></i>
                </span>
                添加更多
              </span>
            </div>
          </div>
          <div v-else>
            <el-table
              :data="this_address_list"
              style="width: 100%;"
              border
              header-row-class-name="header"
            >
              <el-table-column type="index" align="center" prop="id" label="序号" width="50"></el-table-column>
              <el-table-column align="center" prop="buy_date" label="时间" width="100"></el-table-column>
              <el-table-column align="center" prop="name" label="名称描述" width="200"></el-table-column>
              <el-table-column align="center" prop="brand" label="品牌" width="100"></el-table-column>
              <el-table-column align="center" prop="item_no" label="货号" width="100"></el-table-column>
              <el-table-column align="center" prop="price" label="单价(元)" width="80"></el-table-column>
              <el-table-column align="center" prop="address" label="存放" width="100"></el-table-column>
              <el-table-column align="center" prop="remark" label="备注"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div align="center">
                    <div>
                      <el-link :underline="false" @click="del(scope.row.id)">删除</el-link>
                    </div>
                    <div>
                      <el-link :underline="false" @click="detail(scope.row.id)">详情</el-link>
                    </div>
                    <div>
                      <el-link :underline="false" @click="buy_search(scope.row.name)">购买</el-link>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="批量上传" name="6">
          <div style="padding-top:100px">
            <div align="center" style="margin-bottom:10px;">
              <span>下载模板：</span>
              <span>
                <a
                  target="_blank"
                  :href="serve + '/personal/download_excel?mobile='+mobile+'&token='+token"
                >
                  <el-button
                    icon="el-icon-download"
                    size="mini"
                    style="width:150px;text-align:left;"
                  >点击下载模板</el-button>
                </a>
                <div
                  class="lv3Text"
                  style="margin-bottom:30px;margin-top:10px;position:relative;left:-22px"
                >点击按钮下载批量上传模板</div>
              </span>
            </div>
            <el-upload
              align="center"
              class="upload-demo"
              ref="upload"
              action="https://www.baidu.com"
              :on-change="handlePreview"
              :file-list="fileList"
              :auto-upload="false"
              :limit="1"
            >
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <el-button
                style="margin-left: 10px;"
                size="small"
                type="success"
                @click="submitUpload"
              >上传到服务器</el-button>
              <div slot="tip" class="el-upload__tip">只能上传xlsx文件，且不超过500kb</div>
            </el-upload>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="isRegisted==0" style="background-color:#fff;padding-bottom:250px;">
      <div style="width:500px;margin:0 auto;">
       <img
          :src="serve +'/image/none/noOpenHost.jpg'"
          style="width:500px;"
        />
      </div>
      <div class="lv3Text" align="center" style="font-size:18px;margin-top:50px">
        <div style="margin-bottom:5px;">您暂时没有权限使用库存管理功能，请联系</div>
        <div>
          24小时电话
          <span class="lv0Text">133 1168 8691</span> 开通后即可使用
        </div>
      </div>
    </div>

    <el-dialog
      title="添加存放位置"
      :visible.sync="dialogFormVisible"
      style="width:50%;margin:0 auto;"
      center
    >
      <el-form :model="form">
        <el-form-item label="存放位置" :label-width="formLabelWidth">
          <el-input v-model="address" autocomplete="off" maxlength="8" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="位置排序" :label-width="formLabelWidth">
          <el-input-number
            v-model="address_order_by"
            controls-position="right"
            @change="handleChange"
            :min="1"
            :max="100"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="add_save_address">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      page: 1,
      logList: null,
      file: {},
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      form2: {
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token")
      },
      getSp: null,
      getDialog: false,
      getId: null,
      getTitle: null,
      getNo: null,
      total: 0,
      data: [],
      classArr: [],
      tab: this.$route.params.tab,
      isRegisted: null,
      addDialog: false,
      form: {
        mobile: this.$cookies.get("user"),
        token: this.$cookies.get("token")
      },
      key_word: "",
      nameList: null,
      sClass: null,
      sProject: null,
      class: "试剂",
      dialogFormVisible: false,
      formLabelWidth: "70px",
      address: "",
      address_order_by: 1,
      remark: "",
      address_list: [],
      fileList: [],
      product_class: "",
      show_this_address: 0,
      this_address_list: []
    };
  },
  activated() {
    this.$store.state.user_location = "库存管理";
  },
  watch: {
    $route: {
      handler(route) {
        const that = this;
        if (route.path == "/user/state/1/4") {
          that.initData();
        }
      },
      deep: true
    }
  },
  created() {
    //
    this.axios
      .get(this.serve + "/personal/use_inventory", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        this.isRegisted = res.data;
        if (res.data == 1) {
          this.initData();
          this.change_class();
        }
      });
  },
  methods: {
    this_address(row, column, cell, event) {
      if (column.label != "存放位置") {
        return;
      }
      let id = row.id;
      this.axios
        .get(this.serve + "/personal/this_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.show_this_address = 1;
            this.this_address_list = res.data.data;
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: "本位置暂无数据",
              offset: 400
            });
          }
        });
    },
    setClass() {
      this.product_class = this.class;
    },
    indexMethod(index) {
      return index + 1 + (this.page - 1) * 10;
    },
    submitUpload() {
      let formData = new FormData();
      formData.append("mobile", this.mobile);
      formData.append("token", this.token);
      formData.append("inventory", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(
          this.serve + "/personal/upload_inventory",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              showClose: true,
              type: "success",
              message: "上传成功",
              offset: 400
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    handleRemove(file, fileList) {
      this.file = {};
    },
    handlePreview(file) {
      this.file = file.raw;
    },
    buy_search(e) {
      this.$router.push({ path: "/results?keywords=" + e });
    },
    delete_address(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/personal/delete_save_address", {
              params: {
                mobile: this.$cookies.get("user"),
                token: this.$cookies.get("token"),
                id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.save_address_list();
                this.$message({
                  showClose: true,
                  type: "success",
                  message: "删除成功",
                  offset: 400
                });
              } else {
                this.$message({
                  showClose: true,
                  type: "error",
                  message: "删除失败",
                  offset: 400
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 400
          });
        });
    },
    chaneg_order_by(e, id) {
      this.axios
        .get(this.serve + "/personal/change_order_by", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            to: e,
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.save_address_list();
            this.$message({
              showClose: true,
              type: "success",
              message: "移动成功",
              offset: 400
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: "移动失败",
              offset: 400
            });
          }
        });
    },
    handleChange(value) {
      this.address_order_by = value;
    },
    save_address_list() {
      this.axios
        .get(this.serve + "/personal/save_address_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.address_list = res.data.data;
          } else {
            this.address_list = [];
          }
        });
    },
    add_save_address() {
      this.axios
        .get(this.serve + "/personal/save_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_by: this.address_order_by,
            address: this.address,
            remark: this.remark
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.save_address_list();
            this.dialogFormVisible = false;
            this.address_order_by = 1;
            this.address = "";
            this.remark = "";
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    handleClick(tab, event) {
      if (tab.name == 1) {
        this.class = "试剂";
        this.change_class();
      } else if (tab.name == 2) {
        this.class = "耗材";
        this.change_class();
      } else if (tab.name == 3) {
        this.class = "仪器";
        this.change_class();
      } else if (tab.name == 4) {
        this.class = "技术服务";
        this.change_class();
      } else if (tab.name == 7) {
        this.class = "抗体";
        this.change_class();
      } else if (tab.name == 5) {
        this.show_this_address = 0;
        this.save_address_list();
      }
    },
    change_class() {
      this.axios
        .get(this.serve + "/personal/user_inventory_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1,
            class: this.class
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.data = [];
            this.total = 0;
          }
        });
    },
    //
    detail(e) {
      this.$router.push({ path: "/user/state_detail/" + e });
    },
    search() {
      this.loadData();
    },
    loadData() {
      this.page = 1;
      this.axios
        .get(this.serve + "/personal/user_inventory_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page,
            money_class: this.sClass,
            project: this.sProject,
            class: this.class,
            key_word: this.key_word
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.data = [];
            this.total = 0;
          }
        });
    },
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/personal/del_inventory", {
              params: {
                mobile: this.mobile,
                token: this.token,
                id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.$message({
                  showClose: true,
                  type: "success",
                  message: "已删除",
                  offset: 400
                });
                this.axios
                  .get(
                    this.serve + "/personal/user_inventory_list",
                    {
                      params: {
                        mobile: this.$cookies.get("user"),
                        token: this.$cookies.get("token"),
                        page: 1,
                        class: this.class
                      }
                    }
                  )
                  .then(res => {
                    if (res.data.data) {
                      this.data = res.data.data.results;
                      this.total = res.data.data.total;
                    } else {
                      this.data = [];
                      this.total = 0;
                    }
                  });
              } else {
                this.$message({
                  showClose: true,
                  type: "error",
                  message: res.data.msg,
                  offset: 400
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 400
          });
        });
    },
    getFile(event) {
      this.file = event.target.files[0];
    },
    post() {
      let formData = new FormData();
      formData.append("mobile", this.mobile);
      formData.append("token", this.token);
      formData.append("inventory", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(
          this.serve + "/personal/upload_inventory",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "上传完成",
              type: "success"
            });
            this.axios
              .get(this.serve + "/personal/upload_inventory_log", {
                params: {
                  mobile: this.$cookies.get("user"),
                  token: this.$cookies.get("token"),
                  page: 1
                }
              })
              .then(res => {
                if (res.data.data) {
                  this.logList = res.data.data;
                } else {
                  this.logList = {};
                }
              });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    submit2() {
      this.axios
        .get(this.serve + "/personal/get_inventory", {
          params: this.form2
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.getDialog = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    changePage2(p) {
      this.axios
        .get(this.serve + "/personal/upload_inventory_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: p
          }
        })
        .then(res => {
          if (res.data.data) {
            this.logList = res.data.data;
          } else {
            this.logList = {};
          }
        });
    },
    changePage(p) {
      this.axios
        .get(this.serve + "/personal/user_inventory_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: p,
            class: this.class,
            project: this.sProject
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.data = [];
            this.total = 0;
          }
        });
    },
    get(id, title, no, sp) {
      this.getId = id;
      this.form2.id = id;
      this.getDialog = true;
      this.getTitle = title;
      this.getNo = no;
      this.getSp = sp;
    },

    initData() {
      if (this.tab == 1) {
        this.class = "试剂";
      } else if (this.tab == 2) {
        this.class = "耗材";
      } else if (this.tab == 3) {
        this.class = "仪器";
      } else if (this.tab == 4) {
        this.class = "技术服务";
      } else if (this.tab == 7) {
        this.class = "抗体";
      } else if (this.tab == 5) {
        this.save_address_list();
      }
      this.axios
        .get(this.serve + "/personal/user_inventory_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1,
            class: this.class
          }
        })
        .then(res => {
          if (res.data.data) {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.data = [];
            this.total = 0;
          }
        });
      this.axios
        .get(this.serve + "/personal/host_name_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data) {
            this.nameList = res.data.data;
          }
        });
      this.axios
        .get(this.serve + "/personal/project_class", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.classArr = [];
          for (var item of res.data) {
            for (var item2 of item.children) {
              this.classArr.push(item2);
            }
          }
        });
      this.axios
        .get(this.serve + "/personal/upload_inventory_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1
          }
        })
        .then(res => {
          if (res.data.data) {
            this.logList = res.data.data;
          } else {
            this.logList = [];
          }
        });
    }
  }
};
</script>
<style lang="scss">
#state {
  //
  .header .cell {
    padding: 0;
    text-align: center;
    color: #333;
  }
  .header th {
    background-color: #f5faf9;
  }
  .el-link:hover {
    color: #2eacff;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #f5f7fa;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
}
</style>